import useScrollReset from "../../hooks/useScrollReset"

interface Props {
  data: any
}

const QuizResult = ({ data }: Props) => {
  useScrollReset()
  console.log('지훈요청: 최하단에 "검사결과 PDF로 저장하기", "검사 다시하기" 버튼 추가')
  return (
    <>
      <div
        style={{ minHeight: "100vh", paddingTop: 100, paddingLeft: 50 }}
        dangerouslySetInnerHTML={{ __html: data }}
      />
    </>
  )
}

export default QuizResult
